export class User {

  id: number
  email: string;
  name: string;
  addressId: number;
  addressName: string;
  phone: string;
  phoneCode: string;
  profileImg: string;
  status: number

	constructor( u ?: any) {
    this.id = u ? u.id : null;
    this.email = u ? u.email : null;
    this.name = u ? u.name : null;
    this.addressId = u ? u.address_id : null;
    this.addressName = u ? u.address_name : null;
    this.phone = u ? u.phone : null;
    this.phoneCode = u ? u.phone_code : null;
    this.profileImg = u ? u.profile_img : null;
    this.status = u ? u.status : null;
  }
  
  mapUser(list: any[]): User[] {
    let newList: User[] = [];
    list.forEach((item: any) => {
      let newItem: User = new User(item);
      newList.push(newItem);
    });
    return newList;
  }

}
